// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"60":"14bf2b9714","326":"d53406adcd","784":"aa67da4c0a","870":"d87a4de45f"}[chunkId] + ".js";
};